import { useEffect, useState } from 'react';
import { findDocumentByKey } from '../firebase-utils';
import { ReportData } from '../types/types';

type Props = {
  token?: string;
};

interface ReviewsDataResponse {
  data: ReportData | undefined;
  loading: boolean;
}

const useAnalysisData = ({ token }: Props): ReviewsDataResponse => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<ReportData>();

  useEffect(() => {
    if (!token) {
      return;
    }

    refreshData();
  }, [token]);

  const refreshData = async () => {
    setIsLoading(true);
    if (token) {
      const response = await findDocumentByKey<ReportData>('token', token);
      const data = response.data;
      setData(data);
    }
    setIsLoading(false);
  };

  return {
    loading: isLoading,
    data,
  };
};

export { useAnalysisData };
